import { VariableKindPrefix } from '../variables.model'

export const isQuoteLineVariable = (variableId: string) =>
  variableId.startsWith(`${VariableKindPrefix.QUOTE_LINE}_`)
